<template>
  <v-card elevation="2" shaped class="ma-1">
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Paramètres du module Formulaire </v-toolbar-title>
    </v-toolbar>

    <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
        <v-tab> Paramètres généraux</v-tab>
          <v-tab> création de la requete </v-tab>

          <v-tabs-items v-model="tab" class="pl-4">

          <v-tab-item>
          renseignez les champs qui lors de leurs changmeent, va recharger le module configurateur
                  <Autocomplete :item="{
                  defaultprops:{ show: true, chips:true,multiple:true,deletablechips:true },
                  name: 'Liste des champs qui vont recharger le module lors de leur changement',
                  value: 'none',
                  liste: fieldsInModuleTable,
                  }" :change="(item,value,sel)=> {changeActions(item,value) }" :valField="displays.params.fieldsselector" />

            <!-- Mapping fields used by devisconfig to write values into form fields -->
            <Select
                :item="{name: 'Champ de reception id element selectionne',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldreceptoritemid = value?.value??''; }"
                :valField="displays.params.fieldreceptoritemid"
            />
            <Select
                :item="{name: 'Champ de reception des options',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldreceptor = value?.value??''; }"
                :valField="displays.params.fieldreceptor"
            />
            <!-- Mapping added: total sale amount -->
            <Select
                :item="{name: 'Champ de reception total vente',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldreceptorvente = value?.value??''; }"
                :valField="displays.params.fieldreceptorvente"
            />
            <!-- Mapping added: total purchase amount -->
            <Select
                :item="{name: 'Champ de reception total achat',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldreceptorachat = value?.value??''; }"
                :valField="displays.params.fieldreceptorachat"
            />
            <!-- Mapping added: total installation amount -->
            <Select
                :item="{name: 'Champ de reception total pose',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldreceptorpose = value?.value??''; }"
                :valField="displays.params.fieldreceptorpose"
            />
            <!-- Mapping added: cumulative HTML description from selected options -->
            <Select
                :item="{name: 'Champ de reception description cumulee',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldreceptordescr = value?.value??''; }"
                :valField="displays.params.fieldreceptordescr"
            />
            <Select
                :item="{name: 'Champ de reception fournisseur',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldreceptorfournisseur = value?.value??''; }"
                :valField="displays.params.fieldreceptorfournisseur"
            />
            <TextField
                :item="{value:'cle',name:'AS fournisseur dans la requete',defaultprops:{show:true,description:'Ex: fournisseur, fournisseur_id',persistenthint:true}}"
                :keyup="(item,model)=> { displays.params.fieldfournisseur = model }"
                :valField="displays.params.fieldfournisseur"
            />
            <Select
                :item="{name: 'Champ sujet à hauteur (si il y a)',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldhauteur = value?.value??''; }"
                :valField="displays.params.fieldhauteur"
            />
            <Select
                :item="{name: 'Champ sujet à largeur (si il y a)',value: 'table',liste: fieldsInModuleTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.fieldlargeur = value?.value??''; }"
                :valField="displays.params.fieldlargeur"
            />
              <SwitchC 
              :change="(item,value) => {displays.params.grille.set = value}"
              :valField="displays.params.grille.set"
              :item="{name:'appliquer une grille de prix en fonction de hauteur et largeur',value:'autogrow',
              defaultprops:{show:true,modelRules:[],class:'pa-0 ma-0'}}"
              /> 
              <div v-if="displays.params.grille.set">
              <Select
                :item="{name: 'Provenance des grilles',value: 'table',liste: [{text:'de la requete du module',value:'request'},{text:'à partir d\'un fichier',value:'file'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => {displays.params.grille.from = value?.value??''; }"
                :valField="displays.params.grille.from"
              />    
              <p v-if="displays.params.grille.from=='request'">Mentionnez le "AS" de la requete</p>
                <TextField 
                :item="{value:'cle',name:'Intitulé de grille',defaultprops:{show:true}}"
                :keyup="(item,model)=> { displays.params.grille.path = model }"
                :valField="displays.params.grille.path"
                />             
              </div>
          </v-tab-item>

            <v-tab-item>

            <Select
                :item="{name: 'Table parente ciblée',value: 'table',liste: listTables,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => {displays.params.query.table = value?.value??''; }"
                :valField="displays.params.query.table"
            />
              <p>Mentionnez "libelle" en AS pour l'affichage de l'élément à selectionner</p>
              <p>mentionnez "options" en AS pour la selection des options (champ de type "creation d'option" obligatoire) </p>
                <v-tabs align="start" background-color="blue lighten-5" v-model="tab2" v-if="displays.params.query.table">
                    <v-tab> filtre </v-tab>
                    <v-tab> champs</v-tab>
                    <v-tabs-items v-model="tab2" class="pl-4">
                        <v-tab-item>
                            <Filtre
                                :filtre="displays.params.query.filtre"
                                :table="displays.params.query.table"
                                @recepVal="(data) => {displays.params.filtre = data; $emit('recepVal',displays); }"
                            />
                        </v-tab-item>
                        <v-tab-item>
                 <Fields
                  :table="displays.params.query.table"
                  :champs="displays.params.query.champs"
                  :filter="displays.params.filtre"
                  :modalKey="modalKey"
                  :page="page"
                  @recepVal="(val) => {displays.params.query.champs = val}"
                  />                           
                        </v-tab-item>
                        </v-tabs-items> 
                </v-tabs>




            </v-tab-item>
          
          </v-tabs-items>
            </v-tabs>



  </v-card>
</template>



<script>
/*
        $defaultDevisConfig = array(
            "query" => array("table"=>"","champs"=>array(),"filtre"=>array()),
            //liste des champs qui , lors de leur changements, vont recharger le module.
            "fieldsselector"=>array(),
            //mode d'ouverture du produit qui a été cliqué
            "openmode"=>"inline",
            //le champ qui va recevoir les options cochés
            "fieldreceptor"=>"",
            //afficher les lignes de produits personnalisé.
            "linedisplay"=>array(),
            //interactiion entre le produit choisi et les champs du formulaire. prix finel, otpions, fourn etc.
            //le module va générer les résultats de plusieurs calculs en fonction des options choisis : total HT et TTC + montant de la taxe, + certains champs issues de la requete qui peuvent etre mis dans le corps du devis. ex : description du produit, référence etc.
            "fieldmap"=>array()
        );
        $buildingParameters['devisconfig'] = array(
            "defaultquery"=>array("table"=>"","champs"=>array(),"filtre"=>array()),
            "generateddatas"=>array("totalht","totaltva","totalttc"),
            "mapfield"=>array("targetfield"=>"","datas"=>"")
        );
*/
    import { admin } from '../mixins'; 
export default {
  name: "devisConfig",

   mixins : [admin],

  data: function () {
    return {
      tab : '',
      tab2 : '',
      allFields : [],
      displays: this.module.displays,
      dataTableField: [],
      listTables : [],
      fieldsInModuleTable : []
    };
  },

  watch: {

  },

  methods: {
  
    changeActions(item,value) {
      var fields = []
      for(var selected in value) {
        if(typeof value[selected] == 'object') { fields.push(value[selected].value) } else { fields.push(value[selected]); }
      }
      this.displays.params.fieldsselector = fields
    },

  },


  mounted() {
      this.API({type:'get', url:'engine/getlisttable'}).then((resp) => {
                    resp.data.forEach((table) => {
                        this.listTables.push({text:table,value:table})
                    })
                    
                })


        //récupère tous les champs pour la liaison date début et fin de la table du module
        this.getListField({filter:{table:this.module.table}}).then((resp) => {      
  
                  if(Array.isArray(resp)) {
                      resp.forEach((field) => {
                          this.fieldsInModuleTable.push({"text":field.displays.name+' ('+field.cle+')',"value":field.cle})
                      })                             
                  }                                                
                }) 
  },
};
</script>

